<app-view-title Title="{{ 'Intellitrailer.Booking.BeginBooking.SignIn ' | translate : 'Sign in' }}" mode="split" webMode="primary"></app-view-title>

<view-content [nopadding]="true" [fullscreen]="true" [centered]="true">
  <content-header [keyboardOpen]="keyboardOpen">
    @if (currentStep == 1) {
    <h1>{{ 'Intellitrailer.Booking.BeginBooking.Verification ' | translate : 'Verification' }}</h1>
    <h2>{{ 'Intellitrailer.Booking.BeginBooking.Explanation ' | translate : 'Enter the code from your sms' }}</h2>
    } @else {
    <img class="logo" src="/Styles/{{appSettings.settings.theme}}/Logo.png" />
    }
  </content-header>
  <div class="sign-in-content">
    <title-with-divider [titlewithmargin]="true">
      @if (fromPath === 'MyPage') {
      <h1>{{ 'Intellitrailer.Booking.BeginBooking.SignIn ' | translate : 'Sign in' }}</h1>
      }
      @if (fromPath === 'Booking') {
      <h1>{{ 'Intellitrailer.Booking.BeginBooking.CustomerInformation ' | translate : 'Customer information' }}</h1>
      }
    </title-with-divider>
    @if(UI.loading) {
      <div class="spinner-container">
        <mat-progress-spinner diameter="75" mode="indeterminate" ></mat-progress-spinner>
        <h2>{{ UI.loading.messageTranslationKey | translate : UI.loading.translationDefault }}</h2>
      </div>
      }
      @else {
      @if (currentStep == 0) {
      <app-customer-form-component #frmCustomer [showFields]="['Email', 'MobilePhone']" [(customer)]="customer" (inputFocused)="keyboardToggle($event)"></app-customer-form-component>
      <app-recaptcha (verified)="onCaptchaVerified($event)"></app-recaptcha>
      }

      @if (currentStep == 1) {
      <app-verify-account #frmValidation (resendVerification)="sendVerificationCode($event)" (verificationCode)="verify($event)"></app-verify-account>

      <mat-error *ngIf="validationFailed">
        {{ 'Intellitrailer.MyPage.ValidateAccount.InvalidCode' | translate : 'The code entered was invalid.' }}
      </mat-error>
      @if (!codeSentAgain) {
      <p>{{ 'Intellitrailer.MyPage.ValidateAccount.QuestionRecievedCode' | translate : 'Did you not recieve a code?' }}</p>
      @if (firstCode) {
      <p>
        <a href="javascript:void(0)" (click)="sendVerificationCode(true)">
          {{ 'Intellitrailer.MyPage.ValidateAccount.SendNewCode' | translate : 'Send new code' }}
        </a>
      </p>
      } @else {
      <p>
        {{ 'Intellitrailer.MyPage.ValidateAccount.Sent' | translate : 'Sent!' }}
        <a [routerLink]="" (click)="sendVerificationCode(true)">
          ({{ 'Intellitrailer.MyPage.ValidateAccount.SendAnotherCode' | translate : 'Send another code' }})
        </a>
      </p>
      }
      } @else {
      <p>{{ 'Intellitrailer.MyPage.ValidateAccount.SendingNewCode' | translate : 'Sending new code' }}...</p>
      }

      <p>
        <a href="javascript:void(0)" (click)="currentStep = 0">
          {{ 'Intellitrailer.MyPage.ValidateAccount.ChangePhoneNumber' | translate : 'Change phone number' }}
        </a>
      </p>
      }
      }
    </div>

</view-content>

@if (currentStep == 0) {
<view-actions>
  <button type="button" mat-raised-button (click)="confirmData(frmCustomer.validate())">
    {{ 'Intellitrailer.Navigation.Next' | translate : 'Next' }}
  </button>
</view-actions>
}
